module.exports = __webpack_public_path__ + "img/select-all.640eef6c.svg";